// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote_quote__bWjPr","wrapper":"Quote_wrapper__KpT4x","column":"Quote_column__H550L","inner":"Quote_inner__qSX2Z"};